<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box has-background-light">
        <h3 class="is-size-3">בחירת מורים</h3>
        <div class="box filter-teachers">
          <input
            type="text"
            class="input"
            placeholder="סינון לפי שם"
            v-model="term"
            @keyup="filterTeachers"
          />
          <button
            class="button is-danger is-light"
            v-if="term.length > 0"
            @click="clear"
          >
            &Cross;
          </button>
        </div>
        <div class="teacher-list">
          <zoom-x-transition :group="true" tag="div">
            <teacher-item
              v-for="teacher in show"
              :key="teacher.id"
              :teacher="teacher"
            ></teacher-item>
          </zoom-x-transition>
        </div>
      </div>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="close"
    ></button>
  </div>
</template>

<script>
import TeacherItem from "@/components/teacherItem.vue";
import { ZoomXTransition } from "vue2-transitions";

export default {
  components: {
    TeacherItem,
    ZoomXTransition
  },
  data() {
    return {
      term: "",
      show: this.$store.state.data.teachers
    };
  },
  methods: {
    close() {
      this.$store.dispatch("toggleTeachersModal", false);
    },
    filterTeachers() {
      let filtered = [];
      if (this.term.length > 0) {
        filtered = this.$store.state.data.teachers.filter(teacher =>
          teacher.name.includes(this.term)
        );
        this.show = filtered;
      } else {
        this.show = this.$store.state.data.teachers;
      }
    },
    clear() {
      this.term = "";
      this.show = this.$store.state.data.teachers;
    }
  }
};
</script>

<style lang="scss">
.modal-content {
  width: 1320px;

  .teacher-list > div {
    display: flex;
    flex-wrap: wrap;
  }

  .filter-teachers {
    display: flex;
    .button {
      margin-right: 0.5rem;
    }
  }
}
</style>
  

